module.exports = __webpack_public_path__ + "img/img01.42aae1ed.png";